<template>
  <div>
    <div v-if="!isLoading">
      <p style="text-align: center; font-size: 24px;">Google Assistant would like access to your SmartShoppingList account to
        <span style="font-weight: bold;">create, modify, and delete</span> items from your shopping lists.</p>
      <img src="../assets/google_signin.png" @click.prevent="login" style="width: 200px; margin: 0 auto; display: block; cursor: pointer;">
    </div>
    <v-dialog v-model="isLoading" persistent max-width="200px">
      <v-card>
        <v-card-title style="font-weight: bold; font-size: 20px;">Loading...</v-card-title>
        <v-card-text>
          <v-progress-circular indeterminate color="accent" style="margin: 0 auto; display: block;" size="64"></v-progress-circular>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import axios from 'axios';

export default {
  name: 'oauth-signin',
  data() {
    return {
      isLoading: true
    };
  },
  computed: {
    querys: function() {
      return this.$route.query;
    },
    state: function() {
      return this.getParameterByName('state', window.location);
    }
  },
  methods: {
    login: function() {
      var provider = new firebase.auth.GoogleAuthProvider();

      firebase.auth().signInWithRedirect(provider);
    },
    getParameterByName: function(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  },
  mounted() {
    if (firebase.auth.UserCredential) {
      this.isLoading = true;
    } else {
      this.isLoading = false;
    }

    if (
      this.getParameterByName('client_id', window.location) !=
      '229669471138-oujgh11fmneh1a77v6hjmjak5psuut0j.apps.googleusercontent.com'
    ) {
      this.$router.push('/');
    }

    firebase
      .auth()
      .getRedirectResult()
      .then(
        function(result) {
          if (result.credential) {
            axios
              .post('https://us-central1-smartshoppinglist-6052b.cloudfunctions.net/generateToken/execute', {
                uid: result.user.uid
              })
              .then(
                function(response) {
                  const data = response.data;
                  if (data.success) {
                    window.location.href = `https://oauth-redirect.googleusercontent.com/r/smartshoppinglist-6052b#access_token=${
                      data.token
                    }&token_type=bearer&state=${this.state}`;
                  } else {
                    console.log('UNSUCCESSFUL');
                  }
                }.bind(this)
              )
              .catch(function(error) {
                console.log('ERROR: ' + error);
              });
          }
        }.bind(this)
      )
      .catch(function(error) {
        console.error('RDR: ' + error);
      });
  }
};
</script>

<style>
</style>
